import type { RouteObject } from 'react-router'

import { ClientsPage } from '@/features/clients/ClientsPage'

export const routes: RouteObject[] = [{ path: 'clients', element: <ClientsPage /> }]
